// import React from "react";
// import "./PropertyVideo.css";
// import YouTubeThumbnails from "./YouTube";
// const PropertyVideo = () => {
//     return (
//         <div className="property-video-wrapper">
//             <div className="property-video-container">

//                 {/* Heading */}
//                 <h1 className="property-title">
//                     Angel Villa – Open Plots & Commercial Shops
//                 </h1>

//                 {/* Video Section */}
//                 <YouTubeThumbnails />

//                 {/* Content */}
//                 <div className="property-content">
//                     <h2>Project Overview</h2>
//                     <p>
//                         Angel Villa is a well-planned real estate project offering
//                         residential open plots and commercial shops at a prime and
//                         fast-developing location. Ideal for living, business, and
//                         long-term investment.
//                     </p>

//                     <h3>Property Highlights</h3>
//                     <ul>
//                         <li>Residential Open Plots Available</li>
//                         <li>Commercial Shops for Sale</li>
//                         <li>Prime & Developing Location</li>
//                         <li>Clear Documentation</li>
//                         <li>High Return Investment Opportunity</li>
//                     </ul>

//                     <h3>Location</h3>
//                     <p>Angel Villa – Aekta Residency ke bagal, Jitali, Ankleshwar</p>

//                     <div className="contact-box">
//                         <span>📞 Contact for Site Visit:</span>
//                         <strong> +91-8487916787 | +91-6355076803</strong>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default PropertyVideo;


import React from "react";
import "./PropertyVideo.css";
import YouTubeThumbnails from "./YouTube";

const PropertyVideo = () => {
    return (
        <div className="property-video-wrapper">
            <div className="property-video-container">

                {/* Heading */}
                <h1 className="property-title">
                    Property Site Visit Videos
                </h1>

                {/* Video Section */}
                <YouTubeThumbnails />

                {/* Content */}
                <div className="property-content">

                    <h2>Explore Our Real Estate Projects</h2>
                    <p>
                        Watch detailed site visit videos of our residential and
                        commercial projects. Our YouTube videos showcase open plots,
                        villas, commercial shops, road connectivity, surrounding
                        development, amenities, and complete project overviews to
                        help you make the right investment decision.
                    </p>

                    <h3>What You’ll See in These Videos</h3>
                    <ul>
                        <li>Residential Open Plot Site Visits</li>
                        <li>Commercial Shop Projects</li>
                        <li>Property Location & Road Connectivity</li>
                        <li>Nearby Facilities & Development</li>
                        <li>Actual Project Walkthroughs</li>
                        <li>Investment & Future Growth Opportunities</li>
                        <li>On-Site Video Updates</li>
                    </ul>

                    <h3>Why Watch Our Property Videos?</h3>
                    <p>
                        Our videos provide a real-time view of every project so you
                        can easily understand the location, surroundings, plot
                        planning, commercial opportunities, and ongoing development
                        before visiting the site physically.
                    </p>

                    <h3>Available Property Categories</h3>
                    <ul>
                        <li>Open Residential Plots</li>
                        <li>Commercial Shops & Offices</li>
                        <li>Weekend Villa Projects</li>
                        <li>Investment Properties</li>
                        <li>New Launch Projects</li>
                    </ul>

                    <div className="contact-box">
                        <span>📞 Contact for Site Visit & Booking:</span>
                        <strong> +91-8487916787 </strong>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default PropertyVideo;